export const cityProfileSample = {
    id: 52,
    active: true,
    activeDate: 1722199962.469263,
    address: {
        adminAreaLevel1: "ON",
        adminAreaLevel2: "Toronto",
        country: "Canada",
        fullAddress: "100 Queen St W, Toronto, ON, M5H 2N2, Canada",
        cacheExpiryDate: 1725221895,
        locality: "Toronto",
        point: {
            lat: 43.65250220000001,
            lng: -79.3847251,
        },
        postal: "M5H 2N2",
        streetNumber: "100",
    },
    description:
        "The municipal government of Toronto (incorporated as the City of Toronto) is the local government responsible for administering the city of Toronto in the Canadian province of Ontario. Its structure and powers are set out in the City of Toronto Act.\n\nThe powers of the City of Toronto are exercised by its legislative body, known as Toronto City Council, which is composed of 25 members and the mayor. The council passes municipal legislation (called by-laws), approves spending, and has direct responsibility for the oversight of services delivered by the city and its agencies.\n\nThe mayor of Toronto serves as the chief executive officer and head of council. The day-to-day operation of the municipal government is managed by the city manager who is a public servant and head of the Toronto Public Service – under the direction of the mayor and the council. The government employs over 38,000 public servants directly, as well as affiliated agencies. Its operating budget was CA$20.53 billion in 2023, including over $5.1 billion for the Toronto Transit Commission and $4 billion on emergency service agencies, such as the Toronto Police Service, Fire Services and Paramedic Services.\n\n\n",
    files: [
        {
            path: require("@/assets/city-profile/city-sample-1.png"),
            mime_type: "image/png",
        },
        {
            path: require("@/assets/city-profile/city-sample-2.png"),
            mime_type: "image/png",
        },
        {
            path: require("@/assets/city-profile/city-sample-3.png"),
            mime_type: "image/png",
        },
    ],
    lastModified: 1722630295.930333,
    listingDate: 1722199962.475071,
    listingType: "city_service",
    owner: 3,
    ownerInformation: {
        aboutMe: null,
        email: "clarkyangjw@gmail.com",
        firstName: "Clark",
        id: 3,
        lastName: "Yang",
        mobile: "+1 647-877-3008",
        personal_brokerage_image: null,
        personal_brokerage_name: null,
        phone: "+1 647-877-3008",
        professional_title: null,
        profilePicture: 9,
    },
    primaryImage: {
        path: require("@/assets/city-profile/city-sample-1.png"),
        mime_type: "image/png",
    },
    tags: [],
    title: "Sample City Profile -- Toronto",
    services: {
        CITY_HALL: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        MAYOR_OFFICE: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        CHIEF_ADMINISTRATOR: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        CLERK_PROPERTY_CLAIM: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUILDING_PERMITS: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUILDING_PLANNING: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUILDING_INSPECTIONS: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUSINESS_DEVELOPMENT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        ENVIRONMENTAL_SERVICES: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        PROPERTY_ASSESSMENT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        PROPERTY_INVESTIGATION: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        FIRE_CODE_ENFORCEMENT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        ROADS_TRANSPORTATION: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        TREE_SERVICES: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        SEWAGE_DEPT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUILDING_DEPT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        PLANNING_DEPT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        BUSINESS_DEPT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        URBAN_DRAINAGE: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        WATER_DEPT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        WASTE_AMANAGEMENT: '{"phone":"+1 6470001234","email":"cityhall@gmail.com","type":"CITY_HALL"}',
        POLICE: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        FIRE: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        HOSPITAL: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        AMBULANCE: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        POISON: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        HUMANE_SOCIETY: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        LEGAL_AID: '{"phone":"+1 6470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        WALK_IN_CLINIC: '{"phone":"+16 470001234","email":"emergency@gmail.com","type":"EMERGENCY"}',
        GAS: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        HYDRO: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        WATER: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        CABLE: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        PHONE: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        WASTE: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        SEWERS: '{"phone":"+1 6470001234","email":"utilities@gmail.com","type":"UTILITIES"}',
        ELECTRONICS: '{"phone":"+1 6470001234","email":"recycling@gmail.com","type":"RECYCLING"}',
        PAINTS: '{"phone":"+1 6470001234","email":"recycling@gmail.com","type":"RECYCLING"}',
        TIRES: '{"phone":"+1 6470001234","email":"recycling@gmail.com","type":"RECYCLING"}',
        PLASTICS: '{"phone":"+1 6470001234","email":"recycling@gmail.com","type":"RECYCLING"}',
        OTHER: '{"phone":"+1 6470001234","email":"recycling@gmail.com","type":"RECYCLING"}',
    },
    articles: [
        {
            description:
                "The City of Toronto hosts an annual New Year Eve’s celebration featuring a variety of family-friendly entertainment. Sign up for the Celebrate Toronto eNewsletter to receive email updates about City-run festivals and events, including New Year’s Eve. See you on December 31.",
            image: {
                imageId: {
                    path: require("@/assets/city-profile/city-article-1.png"),
                    mime_type: "image/png",
                },
                imageLink: null,
                url: null,
            },
            title: "New Year’s Eve",
            article_type: "NEWS",
        },
        {
            description:
                "Celebrate everything you love about Canada with the City of Toronto’s annual Canada Day fireworks and daytime events. Further details are announced in June. Sign up for the Celebrate Toronto eNewsletter to receive email updates about Canada Day and other City-run events.",
            image: {
                imageId: {
                    path: require("@/assets/city-profile/city-article-2.png"),
                    mime_type: "image/png",
                },
                imageLink: null,
                url: null,
            },
            title: "Canada Day",
            article_type: "IMPORTANT_INFORMATION",
        },
        {
            description:
                "Returns May 24 & 25, 2025\nEach May, Doors Open Toronto invites the public to explore the city’s most-loved buildings and sites, free of charge. The event provides rare access to buildings that are not usually open to the public and free access to sites that would usually charge an admission fee. Since its inception in 2000, it has attracted more than two million visits to nearly 700 unique locations and remains the largest event of its kind in Canada.\n\nSign up for the CelebrateTO eNewsletter to receive email updates about all City-run festivals and events, including Doors Open Toronto.",
            image: {
                imageId: {
                    path: require("@/assets/city-profile/city-article-3.png"),
                    mime_type: "image/png",
                },
                imageLink: null,
                url: null,
            },
            title: "Doors Open Toronto",
            article_type: "OTHER",
        },
    ],
};
